<template>
    <div>
        <section class="hero family-tree">
            <div class="family-tree__container-left hero__left container">
                <div class="family-tree__section hero__container hero__container--big-margin">
                    <div class="hero__body">
                        <div class="hero__info">
                            <div
                                class="family-tree__description benefit__tag benefit__tag--big-margin">
                                {{ $lang('ft.page.title1') }}
                            </div>
                            <h1
                                class="family-tree__hero-title title title--m title--uppercase hero__title hero__title--w650"
                            >
                                {{ $lang('ft.page.title2') }}
                            </h1>
                            <div class="family-tree__hero-text hero__text hero__text--w600"
                            >
                                {{ $lang('ft.page.text1') }}
                            </div>

                            <div class="family-tree__create-btn">
                                <router-link
                                    v-if="!isAuth"
                                    :to="{ name: 'login', query: {'redirect': '/cabinet/tree'} }"
                                    class="btn btn--big btn--main-bg hero__link hero__create ft-font"
                                >
                                    {{ $lang('ft.btn.create') }}
                                </router-link>
                                <a v-if="isAuth && !isNotUser" :href="this.prefix + '/cabinet/tree'"
                                   class="family-tree__follow-btn btn btn--big btn--main-bg hero__create ft-font">
                                   {{ $lang('ft.btn.tree') }}
                                </a>
                                <router-link
                                    v-if="!isAuth"
                                    :to="{ name: 'registration', query: {'redirect': '/cabinet/tree'} }"
                                    class="link span ft-font"
                                >
                                    <span>{{ $lang('registration.title') }}</span>
                                </router-link>
                            </div>

                            <div class="family-tree__benefits">
                                <div v-for="item in benefits" class="family-tree__benefit-item">
                                    <img class="family-tree__benefits-img"
                                         :src="'/assets/front/img/family-tree/' + item.icon">
                                    <div class="family-tree__benefit-text">
                                        {{ item.text }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="family-tree__img">
                    <img src="/assets/front/img/family-tree/ft-tree.png" alt="img"/>
                </div>
            </div>
        </section>

        <section id="romanov" class="romanov-section">
            <div class="container romanov-section__container">
                <div class="tree__body">
                    <a
                        :href="this.prefix + '/familytree'"
                        class="tree__body--btn link span"
                    >
                        <span>{{ $lang('welcome.ft.page')}}</span>
                    </a>
                    <div class="container romanov-section__welcome-container">
                        <div class="romanov-section__romanov">
                            <img class="romanov-section__romanov-image" src="/assets/front/img/family-tree/romanov-photo.png" alt="">
                        </div>
                        <div class="romanov-section__laptop">
                            <img class="romanov-section__laptop-image" src="/assets/front/img/family-tree/laptop.png" alt="">
                        </div>
                        <div class="romanov-section__arrow">
                            <img src="/assets/front/img/family-tree/arrow.png" alt="">
                        </div>
                    </div>
                    <div class="romanov-section__info romanov-section__welcome-info">
                        <h2 class="romanov-section__title">
                            {{ $lang('romanov.title') }}
                        </h2>
                        <p class="romanov-section__text">
                            {{ $lang('romanov.text') }}
                        </p>
                            <a
                                target="_blank"
                                href="https://familytree.memorycode.ru/share/22089346"
                                class="btn btn--big btn--main-bg romanov-section__link ft-font">
                                {{ $lang('romanov.tree') }}
                            </a>
                    </div>
                </div>
            </div>
        </section>

        <section class="advantages-section container" id="advantages">
            <div class="cta-banner__block advantages-section__img-card">
                <img src="/assets/front/img/family-tree/advantages-memory.svg" alt="img">
                <h3 class="advantages-section__img-card--title">{{ $lang('advantage.ft.title1') }}</h3>
                <p class="advantages-section__img-card--text">{{$lang('advantage.ft.text1')}}</p>
                <img class="info__bg cta-banner__bg" src="/assets/front/img/family-tree/advantages-building-img.png"
                     alt="img">
            </div>
            <div v-for="(item, index) in advantageItems"
                 class="advantages-section__card"
                 :class="{
                'advantages-section__card--second': index === 1,
                'advantages-section__card--third': index === 2}"
            >
                <img :src="'/assets/front/img/family-tree/' + item.icon" alt="img">
                <h3 class="advantages-section__card-title">
                    {{ item.title }}
                </h3>
                <p
                    class="advantages-section__card-text"
                    :class="{
                    'advantages-section__card-text--first': index === 0,
                    'advantages-section__card-text--forth': index === 3,
                    'advantages-section__card-text--fifth': index === 4,}"
                >
                    {{ item.text }}
                </p>
                <a v-if="index === 2" target="_blank" class="link span ft-font" href="https://memorycode.ru/archive">
                    <span>{{$lang('ft.archive')}}</span>
                </a>
            </div>
            <div class="cta-banner__block advantages-section__img-card">
                <img src="/assets/front/img/family-tree/advantages-code.svg" alt="img">
                <h3 class="advantages-section__img-card--title">{{$lang('advantage.ft.title7')}}</h3>
                <p class="advantages-section__img-card--text">{{$lang('advantage.ft.text7')}}</p>
                <img class="info__bg cta-banner__bg" src="/assets/front/img/family-tree/advantages-share-picture.png"
                     alt="img">
            </div>
        </section>

        <section class="create-tree__section container" id="create-tree">
            <h2 class="create-tree__title">{{ $lang('create.ft.title') }}</h2>
            <div v-if="windowWidth > 767" class="create-tree__wrapper">
                <div v-for="item in swiperSlides" class="create-tree__content">
                    <h3 class="create-tree__number">{{ item.id }}</h3>
                    <img class="create-tree__img" alt="img" :src="'/assets/front/img/family-tree/' + item.icon">
                    <p class="create-tree__text">{{ item.name }}</p>
                    <router-link
                        v-if="item.id === 1"
                        :to="{ name: 'registration', query: {'redirect': '/cabinet/tree'} }"
                        class="link span ft-font"
                        :class="{'registration-disabled': isAuth}"
                    >
                        <span>{{ $lang('registration.title') }}</span>
                    </router-link>
                </div>
            </div>
            <swiper v-if="windowWidth < 768" class="swiper-wrapper swiper-container "
                    :options="swiperOption">
                <swiper-slide v-for="item in swiperSlides" :key="item.id" style="width: 233px"
                              class="swiper-slide f-page__share-slide">
                    <div class="create-tree__wrapper">
                        <div class="create-tree__content">
                            <h3 class="create-tree__number">{{ item.id }}</h3>
                            <img class="create-tree__img" alt="img" :src="'/assets/front/img/family-tree/' + item.icon">
                            <p class="create-tree__text">{{ item.name }}</p>
                            <router-link
                                v-if="item.id === 1"
                                :to="{ name: 'registration', query: {'redirect': '/cabinet/tree'}}"
                                class="link span ft-font"
                                :class="{'registration-disabled': isAuth}"
                            >
                                <span>{{ $lang('registration.title') }}</span>
                            </router-link>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
        </section>

        <section class="faq-section container" id="faq">
            <h2 class="create-tree__title">{{ $lang('faq.title') }}</h2>
            <el-collapse class="faq-section__questions collapse shadow" v-model="activeName" accordion>
                <el-collapse-item v-for="(item, index) in faqItems" :key="item.id" :name="index"
                                  class="faq-section__item">
                    <template slot="title">
                        <div class="collapse__title">
                            <div class="collapse__status"
                                 :class="activeName === index ? 'collapse__status--active' : ''"></div>
                            <span class="faq__question-text" v-html="item.question"></span>
                        </div>
                    </template>
                    <div class="faq__answer faq-section__answer" v-html="item.answer"></div>
                </el-collapse-item>
            </el-collapse>
        </section>

        <section class="registration-section" id="registration">
            <div class="container registration-section__wrapper">
                <div class="registration-section__img">
                    <img alt="img" src="/assets/front/img/family-tree/registration-form.png">
                </div>
                <div>
                    <div class="popup__header registration-section__title">
                        <span class="title popup__title">{{ $lang('registration.title') }}</span>
                    </div>

                    <div class="popup__content registration-section__content">
                        <errors :errors="errors"></errors>
                        <form class="form" @submit.prevent="registerPost">
                            <div class="form__item registration-section__item form__item--inline">
                                <label class="registration-section__input">
                                    <el-input class="input input--big"
                                              :placeholder="$lang('feedback.name.placeholder')"
                                              v-model="formAuth.name" required dusk="auth-name"></el-input>
                                </label>
                            </div>
                            <div class="form__item registration-section__item form__item--inline">
                                <label class="registration-section__input">
                                    <el-input class="input input--big" placeholder="E-mail"
                                              v-model="formAuth.email" dusk="auth-email"></el-input>
                                </label>
                            </div>
                            <div v-if="locale === 'ru'"
                                 class="form__item registration-section__item form__item--inline">
                                <label class="registration-section__input">
                                    <input-phone v-model="formAuth.phone" placeholder="Телефон" class="input input--big" dusk="auth-phone"/>
                                </label>
                            </div>
                            <div class="form__item registration-section__item registration-section__checkbox">
                                <el-checkbox v-model="formAuth.checked" required dusk="auth-checkbox"
                                >{{ $lang('registration.policy.part1') }}
                                    <a class="el-checkbox__link" target="_blank"
                                       href="/assets/front/pdf/memorycode_processing_of_personal_data.pdf">
                                        {{ $lang('registration.policy.part2') }}</a>
                                </el-checkbox>
                            </div>
                            <div class="form__item registration-section__item">
                                <button style="width: 100%"
                                        class="btn btn--middle btn--main-bg ft-font"
                                        :class="{'registration-disabled': isAuth}"
                                        dusk="auth-registration">{{ $lang('registration.button.reg') }}
                                </button>
                            </div>
                            <div class="registration-section__error form__item registration-section__item form__item--inline">
                                <span class="popup__auth-hint">{{ $lang('registration.hint') }}</span>
                                <router-link
                                    class="link ft-font"
                                    :class="{'registration-disabled': isAuth}"
                                    :to="{name: 'login', query: {'redirect': '/cabinet/tree'}}">
                                    <span>{{ $lang('registration.button.login') }}</span></router-link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

import InputPhone from "../../components/InputPhone.vue";
import Errors from "../error/errors.vue";
import width from "../../mixins/width";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
    name: "mcFamilyTree",
    mixins: [width],
    components: {Errors, InputPhone},
    data() {
        return {
            benefits: [
                {
                    icon: 'people-tree.svg',
                    text: Vue.prototype.$lang('ft.benefits.1')
                },
                {
                    icon: 'code-tree.svg',
                    text: Vue.prototype.$lang('ft.benefits.2')
                },
                {
                    icon: 'gift-tree.svg',
                    text: Vue.prototype.$lang('ft.benefits.3')
                }
            ],
            faqItems: [
                {
                    id: 1,
                    question: Vue.prototype.$lang('faq.q1'),
                    answer: Vue.prototype.$lang('faq.ft.a1')
                },
                {
                    id: 2,
                    question: Vue.prototype.$lang('faq.ft.q2'),
                    answer: Vue.prototype.$lang('faq.ft.a2')
                },
                {
                    id: 3,
                    question: Vue.prototype.$lang('faq.ft.q3'),
                    answer: Vue.prototype.$lang('faq.ft.a3')
                }
            ],
            swiperSlides: [
                {
                    id: 1,
                    name: Vue.prototype.$lang('create.ft.1'),
                    icon: 'create-registration.svg'
                },
                {
                    id: 2,
                    name: Vue.prototype.$lang('create.ft.2'),
                    icon: 'create-relations.svg'
                },
                {
                    id: 3,
                    name: Vue.prototype.$lang('create.ft.3'),
                    icon: 'create-share.svg'
                },
            ],
            advantageItems: [
                {
                    icon: 'advantages-people.svg',
                    title: Vue.prototype.$lang('advantage.ft.title2'),
                    text: Vue.prototype.$lang('advantage.ft.text2')
                },
                {
                    icon: 'advantages-gift.svg',
                    title: Vue.prototype.$lang('advantage.ft.title3'),
                    text: Vue.prototype.$lang('advantage.ft.text3')
                },
                {
                    icon: 'advantages-page.svg',
                    title: Vue.prototype.$lang('advantage.ft.title4'),
                    text: Vue.prototype.$lang('advantage.ft.text4')
                },
                {
                    icon: 'advantages-support.svg',
                    title: Vue.prototype.$lang('advantage.ft.title5'),
                    text: Vue.prototype.$lang('advantage.ft.text5')
                },
                {
                    icon: 'advantages-share.svg',
                    title: Vue.prototype.$lang('advantage.ft.title6'),
                    text: Vue.prototype.$lang('advantage.ft.text6')
                }
            ],
            swiperOption: {
                slidesPerView: 'auto',
                spaceBetween: 20,
            },
            prefix: window.laravel.prefix,
            activeQuestion: null,
            activeName: '',
            errors: null,
            showMessage: null,
            locale: window.laravel.locale,
            admin: window.laravel.isAdmin,
            isAdmin: window.laravel.isAdmin,
            isPartner: window.laravel.isPartner,
            isMaster: window.laravel.isMaster,
        }
    },
    computed: {
        ...mapState('auth', [
            'formAuth'
        ]),
        ...mapGetters('auth', [
            'isAuth',
        ]),
        isNotUser() {
            return this.isAdmin || this.isPartner || this.isMaster
        }
    },
    methods: {
        ...mapActions('auth', [
            'register',
        ]),
        ...mapMutations('auth', [
            'clearData',
            'generatePassword',
        ]),
        registerPost() {
            this.generatePassword();
            this.formAuth.sendPassword = true;
            this.formAuth.redirect = '/cabinet/tree';
            this.errors = null;

            this.$loading(this.$optionsLoading);

            this.register().then((response) => {
                this.$dataLayer.push({'event': 'createUser', 'user_id': response.data.user.id});

                if (response.data.user.hasOwnProperty('show_message')) {
                    this.$appNotify.success(response.data.user.show_message);

                    setTimeout(() => {
                        window.location.href = response.data.redirect
                    }, 3000);
                } else {
                    window.location.href = response.data.redirect;
                }
            }).catch((error) => {
                let data = error.response.data;
                data.errors.email_md5 = ''

                if (data.hasOwnProperty('errors')) {
                    this.errors = data.errors;
                } else if (data.message) {
                    this.$appNotify.error(data.message);
                }
            }).finally(() => {
                this.$loading({}).close();
            });
        },
        beforeDestroy() {
            this.$nextTick(() => {
                this.clearData();
            });
        },
    },
}
</script>

<style>
.tree__body--btn {
    display: none;
}
.romanov-section{
    padding-top: 35px;
}
</style>
